<!-- ======= Footer ======= -->
<footer id="footer" class="footer">
  <!-- <div class="dld-guide"> <a href="#"> <span> <i class="bi bi-file-earmark-pdf"></i> User Manual </span> </a> </div>-->
  <div class="copyright"> &copy; Copyright <strong><span>TASMU | Tarsheed </span></strong> All Rights Reserved @ {{currentYear}} </div>
</footer>
<!-- End Footer -->
